import { Injectable, inject } from '@angular/core';
import { AppleProfileStoreSelectors } from '@era/stores';
import { Store } from '@ngrx/store';
import { Device } from '@rocksoft/shared';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AppleDeviceService {
  private readonly store = inject(Store);

  observeAppleDeviceWithLockedFlag(device: Device): Observable<Device> {
    return this.store.select(AppleProfileStoreSelectors.selectSingleAppModeBundleIdentifier(device.udid)).pipe(
      map((bundleIdentifier) => {
        // Set the 'isLocked' flag to true if the application has an SAM profile
        const applicationsWithLockedFlag = device.managedApplications?.map((managedApplication) => {
          return { ...managedApplication, isLocked: managedApplication.identifier === bundleIdentifier };
        });

        return { ...device, managedApplications: applicationsWithLockedFlag };
      })
    );
  }
}
